import React  from 'react';
import styled from 'styled-components/macro'
import Logo from '../assets/Logo.svg';
import Aery from '../assets/Aeco.svg';
import Finance from '../assets/Finance.svg';
import Square from '../assets/Square.svg';
import HalfSquare from '../assets/HalfSquare.svg';

const StyledFooter = styled.div`
    /* Footer */
    width: 100%;
    height: 291px;
    left: 0;
`

const Background = styled.div`
    /* Background */
    height: 291px;
    
    background: linear-gradient(0deg, #161616 0%, rgba(22, 22, 22, 0.73) 153.85%);
    box-shadow: 26px 24px 90px rgba(31, 26, 51, 0.13);
`

const FooterLogo = styled.div`
    /* Frame 164 */
    width: 100%;
    height: 28px;
    display: flex;
    justify-content: center;
`

const CopyRight = styled.div`
    width: 100%;
    height: 17px;
    padding-top: 46px;
    display: flex;
    justify-content: center;
    
    font-family: Lato;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 120%;
    /* identical to box height, or 17px */
    
    align-items: center;
    letter-spacing: 0.08em;
    
    color: #FFFFFF;
    
    opacity: 0.4;
`

const Squares1 = styled.div`
    /* Vector 12 */
    
    width: 123px;
    height: 125px;
    margin-left: 5%;
    align-self: flex-start;

`

const Squares2 = styled.div`
    /* Vector 11 */
    
    width: 123px;
    height: 125px;
    margin-left: auto;
    margin-right: 5%;
    align-self: flex-end;
`

const Squares3 = styled.div`
    /* Vector 8 */
    
    width: 123px;
    height: 158px;
    margin-right: 15%;
    align-self: flex-start;
`

const Squares4 = styled.div`
    /* Vector 9 */
        
    width: 123px;
    height: 158px;
    margin-left: 15%;
    align-self: flex-end;
`

const SquareRow = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
`

const MiddleArea = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: -30px;
`

const LogoRow = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: auto;
  
  :hover {
    cursor: pointer;
  }
`
const LogoIcon = styled.div`
  transition: transform 0.3s ease;
  :hover {
    transform: rotate(-25deg);
  }
`

const AerySVG = styled.div`
  margin-left: 8px;
`

const FinanceSVG = styled.div`
  margin-left: 8px;
`

const Footer = () => {
     return (
         <StyledFooter>
            <Background>
                <SquareRow>
                    <Squares1>
                        <img src={HalfSquare} />
                    </Squares1>
                    <Squares2>
                        <img src={HalfSquare} />
                    </Squares2>
                </SquareRow>
                <SquareRow>
                    <Squares3>
                        <img src={Square} />
                    </Squares3>
                    <MiddleArea>
                        <LogoRow href="/">
                            <LogoIcon>
                                <img src={Logo} />
                            </LogoIcon>
                            <AerySVG>
                                <img src={Aery} />
                            </AerySVG>
                            <FinanceSVG>
                                <img src={Finance} />
                            </FinanceSVG>
                        </LogoRow>
                        <CopyRight>Copyright © Laeco Real Estate Blockchain 2021. All rights reserved</CopyRight>
                    </MiddleArea>
                    <Squares4>
                        <img src={Square} />
                    </Squares4>
                </SquareRow>

            </Background>
         </StyledFooter>
     );
}

export default Footer;